import { render, staticRenderFns } from "./DashboardInfo.vue?vue&type=template&id=effcce70&"
import script from "./DashboardInfo.vue?vue&type=script&lang=js&"
export * from "./DashboardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports